import { Injectable } from '@angular/core';
import { ValidationError } from '../enums/validation-error';
import { ValidationErrorParams } from '../types/validation-error-params';
import { isNil, Nillable } from '@web/utils';
import { EntryNotFoundException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class ValidationErrorMessageProvider {
  /* prettier-ignore */
  private readonly entries = new Map<ValidationError, (params?: Nillable<ValidationErrorParams>) => string>([
    [ValidationError.ArrayMax, (params) => `To pole powinna zawierać co najwyżej ${params?.max} elementów.`],
    [ValidationError.ArrayMin, (params) => `To pole powinno zawierać co najmniej ${params?.min} elementów.`],
    [ValidationError.Custom, (params) => `${params?.message}`],
    [ValidationError.Email, () => `Adres e-mail jest niepoprawny.`],
    [ValidationError.Max, (params) => `Ta wartość powinna być mniejsza bądź równa ${params?.max}.`],
    [ValidationError.MaxLength, (params) => `To pole powinno zawierać co najwyżej ${params?.requiredLength} znaków.`],
    [ValidationError.Min, (params) => `Ta wartość powinna być większa bądź równa ${params?.min}.`],
    [ValidationError.MinLength, (params) => `To pole powinno zawierać co najmniej ${params?.requiredLength} znaków.`],
    [ValidationError.NIP, () => `NIP jest niepoprawny.`],
    [ValidationError.PostCode, () => 'To pole ma nieprawidłowy format kodu pocztowego. Wymagany format to 00-000.'],
    [ValidationError.Required, () => 'To pole jest wymagane.'],
    [ValidationError.SelectionMax, (params) => `To pole powinno zawierać maksymalnie ${params?.max} zaznaczonych elementów.` ],
    [ValidationError.SelectionMin, (params) => `To pole powinno zawierać przynajmniej ${params?.min} zaznaczonych elementów.` ],
    [ValidationError.URL, () => `Adres URL jest niepoprawny.`],
  ]);

  public message(
    key: ValidationError,
    params?: Nillable<ValidationErrorParams>,
  ): string {
    const message = this.entries.get(key);

    if (isNil(message)) {
      throw new EntryNotFoundException(
        `The control error message entry for "${key}" not found.`,
      );
    }

    return message(params);
  }
}
